import { render, staticRenderFns } from "./SelectMode.vue?vue&type=template&id=2cb1412f&scoped=true&"
import script from "./SelectMode.vue?vue&type=script&lang=js&"
export * from "./SelectMode.vue?vue&type=script&lang=js&"
import style0 from "./SelectMode.vue?vue&type=style&index=0&id=2cb1412f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1412f",
  null
  
)

export default component.exports